// extracted by mini-css-extract-plugin
export default {"modal_contents":"styles_modal_contents__uw+YQ","modal_contents_p":"styles_modal_contents_p__+B2bD"};